import { StyleOutlined } from '@mui/icons-material';

import { InformationModalLayout } from 'modules/components/layer13';
import React from 'react';
import * as ds from './dataService';



export type RemoveInstallationTypeModalProps = {
  id: string;
  projectId: string;
  isVisible: boolean;
  handleClose: () => void;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: RemoveInstallationTypeModalProps) => {
  const [
    fnRemoveInstallationType,
    { loading }
  ] = ds.useRemoveInstallationType();
  return (
    <InformationModalLayout.FC
      id={props.id}
      handleClose={props.handleClose}
      title='Remove Selections'
      headerIcon={(
        <StyleOutlined />
      )}
      loading={loading}
      subTitle={'Confirm you want to remove these selections? This can\'t be undone'}
      isVisible={props.isVisible}
      successButton={{
        handleClick: async () => {
          await fnRemoveInstallationType({
            projectId: props.projectId,
            typeId: props.id
          });
          props.handleClose();
        },
        text: 'Remove'
      }}
    />
  );
};
